import applicationRoutes from '../src/routes/applicationRoutes';
// 注意：业务拓展的路由，写到 routes-biz.ts 文件中，便于云枢源码升级时减少代码冲突
import routesBiz from './routes-biz';
export default Object.assign({}, routesBiz, { formDetail: {
        path: "/form/detail",
        name: "form-detail",
        component: () => import("@/views/form/form-detail.vue"),
    }, application: {
        application: Object.assign({}, applicationRoutes.infoPath, { children: [
                ...applicationRoutes.infoChildren,
                ...routesBiz.application,
                {
                    path: 'testApplication/:schemaCode',
                    name: 'testApplication',
                    component: () => import('./views/application-list.vue')
                },
            ] })
    } });
